import {
  MouseEvent,
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState
} from 'react';
import { useDispatch } from 'react-redux';

import { setItem } from '../../../utils/storage';

const TabContext = createContext<{
  id: string;
  setActiveTab: (e: MouseEvent<HTMLDivElement>) => void;
}>({
  id: '',
  setActiveTab: () => {
    // set active tab function
  }
});

const Tab = ({
  tabs,
  defaultTab,
  getActiveTab,
  children,
  classes,
  activeClass,
  bg
}: {
  tabs: { value: string; id: string }[];
  defaultTab?: string;
  getActiveTab?: (activeTabId: string) => void;
  children: ReactNode;
  classes?: string;
  activeClass?: string;
  bg?: string;
}) => {
  const [id, setId] = useState<any>(defaultTab ?? tabs[0]?.id);
  const dispatch = useDispatch();
  useEffect(() => {
    if (getActiveTab) {
      setItem({ key: 'activeTab', value: id });
      getActiveTab(id);
    }
  }, [getActiveTab, id]);

  const setActiveTab = (e: MouseEvent<HTMLDivElement>) => {
    const id = (e.target as HTMLElement).id;
    if (getActiveTab) {
      getActiveTab(id);
    }
    setId(id);
  };

  return (
    <TabContext.Provider value={{ id, setActiveTab }}>
      <div className='h-full w-full overflow-y-auto'>
        <div className={`${bg} flex items-center pt-2`}>
          {tabs.map(tab => {
            return (
              <TabItem
                activeClass={activeClass}
                classes={classes}
                tabName={tab.value}
                key={tab.id}
                tabId={tab.id}
              />
            );
          })}
        </div>
        <div>{children}</div>
      </div>
    </TabContext.Provider>
  );
};

export default Tab;

const TabsBody = ({ children, id }: { children: ReactNode; id: string }) => {
  const { id: activeTab } = useContext(TabContext);

  if (activeTab === id) {
    return <>{children}</>;
  }
  return null;
};
Tab.Body = TabsBody;

const TabItem = ({
  tabName,
  tabId,
  classes,
  activeClass
}: {
  tabName: string;
  tabId: string;
  classes?: string;
  activeClass?: string;
}) => {
  const { id: activeTab, setActiveTab } = useContext(TabContext);
  return (
    <div
      className={`mr-3 ${
        tabId === activeTab ? activeClass : classes
      } cursor-pointer`}
      onClick={setActiveTab}
      id={tabId.toString()}
    >
      {tabName}
    </div>
  );
};
